import { auctioneerPublicKEY } from './pubkeys';

const config = {
  baseUrl: process.env.VUE_APP_API,
  // baseUrl: 'http://192.168.40.229:8080',
  apiPass: 'ssapp:devel',

  authSite: '06c028697564f66f0791ef403900605a',

  recaptcha: '6LfghnQfAAAAACY3YxxjuCRsJ1QwwSB7PmnuZ47R',
  recaptchav3_site_v2_for_appcheck: '6LddyXcrAAAAACkTREugGyL3E5gMHb9qH-ERyR-C',

  typeDocumentsBPV: {
    "chassi": 1,
    "fiscalNote": 2,
    "fiscalNoteAndChassi": 3,
    "crlv": 4
  },

  situationLot: {
    confirmation_data: 1,
    upload_document: 2,
    delivery: 3,
    payment: 4,
    sales_note_issued: 5,
    scheduling_and_withdrawal: 6,
    finished: 7,
    lotPaid: 8
  },

  situationLotJudicial: {
    downloadGuide: 1,
    payment: 2,
    uploadFiles: 3
  },

  statusDelivery: {
    init: 1,
    contracted: 2,
    uncontracted: 3
  },

  statusDocuments: {
    okay: 1,
    waiting_for_approval: 2,
    disapprove: 8,
    approved_with_reservation: 9,
    waiting_for_reanalysis: 10,
    blocked: 11,
    approved_by_sac: 12,
  },

  idDocumentOptional: {
    termResponsibility_second_page: 21
  },

  keyAfterSaleLocalStorage: 'aftersales',

  dateImplamentation: '2022-12-19',
  dateImplementationStorage: '2024-04-09',
  auctionsReleasedForStorage: [7530, 24774, 24817, 24965, 24944, 24967, 25038, 25067, 25080],
  testUsers: {
    // "mainLots": [323335, 292000, 577472, 339058, 85813, 101434, 522356, 7839, 178362, 60624],
    // "favorite": [323335, 292000, 577472, 339058, 101434, 522356, 7839],
    // "disputedLot": [323335, 292000, 577472, 339058, 101434, 522356, 7839],
    // "documents": [323335, 292000, 577472, 339058],
    // "site": [323335, 292000, 577472, 339058, 101434, 522356, 7839]
  },
  siteSodre: 'https://www.sodresantoro.com.br',

  mp_public_key: {
    [auctioneerPublicKEY.LF.id]: auctioneerPublicKEY.LF.value,
    [auctioneerPublicKEY.JE.id]: auctioneerPublicKEY.JE.value,
    [auctioneerPublicKEY.MOACIR.id]: auctioneerPublicKEY.MOACIR.value,
    [auctioneerPublicKEY.FLAVIO.id]: auctioneerPublicKEY.FLAVIO.value,
    [auctioneerPublicKEY.JULIOC.id]: auctioneerPublicKEY.LF.value,
    [auctioneerPublicKEY.OTAVIO.id]: auctioneerPublicKEY.OTAVIO.value,
    [auctioneerPublicKEY.MARIANA.id]: auctioneerPublicKEY.MARIANA.value,
    [auctioneerPublicKEY.CAROLINA.id]: auctioneerPublicKEY.CAROLINA.value,
    [auctioneerPublicKEY.SS.id]: auctioneerPublicKEY.SS.value,
  },

  minimumEnablePayCardCredit: 40,

  mp_public_key_dev: "APP_USR-699d6cbf-b840-44d3-8a16-6911c0d79393",

  testUserMP: {
    name: 'CONT CONT',
    cpf: 12345678909,
    email: 'test_user_1179435023@testuser.com',
    phone: '11987654321',
    isJuridic: false
  },

  disabledPayment: {
    credit_card: [25811, 26556, 26884],
    pix: [26556],
    billet: [28686, 28687, 28688, 28810, 28811, 28812, 28955, 28956, 28957, 28941, 28942]
  },

  discountAuctionLuxury: 0.05,

  disableDownloadSaleNote: {
    clientId: [5607] //desabilita o download da nota de venda
  },

  disableActionsPaymentFlux: {
    delegation: [5607, 1713], //desabilita o botão outros compradores por cliente_ID
    delivery: [5607] // desabilita o botão contratar delivery por cliente_ID
  },

  dateMaintenance: {
    start: '2026-03-06 18:00:00',
    end: '2026-03-07 09:00:00'
  }

}

export default config;
